import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFooter,{attrs:{"padless":""}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12"}},[_c(VBtn,{attrs:{"text":"","small":"","href":"https://abel-porfolio.web.app","target":"_blank"}},[_vm._v(" Designed, Developed and maintained by Abel .S. Sekwala "),_c(VIcon,{attrs:{"right":""}},[_vm._v("mdi mdi-link")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }